module.exports = __webpack_public_path__ + "img/CHBIM_logo2.9b22136d.png";